import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage'
import UserPage from './components/users-component/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import LoginComponent from './components/login-component/login';
import AddClientComponent from './components/client-component/addClient';
import AdminDashboard from './components/dashboard-component/admin-dashboard';
import ClientsComponent from './components/client-component/clients';
import AddPackageComponent from './components/package-component/addPackage';
import AddEmployeeComponent from './components/employee-component/addEmployee';
import EmployeesComponent from './components/employee-component/employees';
import AttendanceManagement from './components/employee-component/attendanceManagement';
import PackagesComponent from './components/package-component/packageList';
import PrintInvoiceComponent from './components/package-component/printInvoice';
import SignupComponent from './components/login-component/signup';
import ForgotPasswordComponent from './components/login-component/forgotPassword';
import GenerateBillComponent from './components/billing-component/generateBill';
import ShowBillsComponent from './components/billing-component/showBills';
import ScanPackage from './components/package-update-component/scanPackage';
import ScannedPackages from './components/package-update-component/scannedPackage' 
import UpdateProfile from './components/update-profile-component/updateProfile'
import ScanOutOfDelivery from './components/package-update-component/scanOutOfDelivery'
import OutOfDeliveryPackages from './components/package-update-component/outOfDeliveryPackages'
import DeliveredScanner from './components/package-update-component/delivered'
import DeliveryLists from './components/package-update-component/deliveryLists'
import Deliveries from './components/package-update-component/deliveries'
import ToPays from './components/package-update-component/toPays'
import Collections from './components/package-update-component/collections'
import AddVehicleComponent from './components/vehicle-component/addVehicle'
import VehiclesComponent from './components/vehicle-component/vehicles'
import EnquiriesComponent from './components/enquiry-component/enquiries'




// ----------------------------------------------------------------------

export default function Router() {
  const isLoggedIn = JSON.parse(localStorage.getItem('user')) ? true : false;
  const routes = useRoutes([
    // {
    //   path: '/dashboard',
    //   element: <DashboardLayout />,
    //   children: [
    //     { element: <Navigate to="/dashboard/user" />, index: true },
    //     { path: 'admin', element: <DashboardAppPage /> },
    //     { path: 'user', element: <UserPage /> },
    //     { path: 'products', element: <ProductsPage /> },
    //     { path: 'blog', element: <BlogPage /> },
    //   ],
    // },
    isLoggedIn && {
      path: '',
      element: <DashboardLayout />,
      children: [
        { path: 'dashboard-admin', element: <AdminDashboard />, index: true },
        { path: 'add-client', element: <AddClientComponent />, index: true },
        { path: 'clients', element: <ClientsComponent />, index: true },
        { path: 'add-package', element: <AddPackageComponent />, index: true },
        { path: 'add-employee', element: <AddEmployeeComponent />, index: true },
        { path: 'employees', element: <EmployeesComponent />, index: true },
        { path: 'attendance', element: <AttendanceManagement />, index: true },
        { path: 'packages', element: <PackagesComponent />, index: true },
        { path: 'print-invoice', element: <PrintInvoiceComponent />, index: true },
        { path: 'generate-billing', element: <GenerateBillComponent /> },
        { path: 'show-bills', element: <ShowBillsComponent /> },
        { path: 'scan-package', element: <ScanPackage />, index: true },
        { path: 'scan-out-of-delivery', element: <ScanOutOfDelivery />, index: true },
        { path: 'delivered', element: <DeliveredScanner />, index: true },
        { path: 'delivery-lists', element: <DeliveryLists />, index: true },
        { path: 'deliveries', element: <Deliveries />, index: true },
        { path: 'to-pays', element: <ToPays />, index: true },
        { path: 'collections', element: <Collections />, index: true },
        { path: 'out-of-delivery-packages', element: <OutOfDeliveryPackages />, index: true },
        { path: 'scanned-packages', element: <ScannedPackages />, index: true },
        { path: 'add-vehicle', element: <AddVehicleComponent />, index: true },
        { path: 'vehicles', element: <VehiclesComponent />, index: true },
        { path: 'enquiries', element: <EnquiriesComponent />, index: true },
        { path: 'update-profile', element: <UpdateProfile />, index: true },






        { path: 'user', element: <UserPage />, index: true },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> }
       
      ],
    },
    {
      path: 'login',
      element: <LoginComponent />,
    },
    {
      path: 'signup',
      element: <SignupComponent/>,
    },
    {
      path: 'reset-password',
      element: <ForgotPasswordComponent/>,
    },
    {
      path: '*',
      element: <LoginComponent />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '404', element: <Page404 /> },
      
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
  


  
  return routes;
}
